import Component from'./component';import EnhanceOnlineDetector from'./enhancers/EnhanceOnlineDetector';export default EnhanceOnlineDetector(Component);